import React, { Component } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import BaseChip from "components/Chip";

import styles from "./styles.module.scss";

export default class Chip extends Component {
  get isDefault() {
    const { areas } = this.props;
    return areas.length === 0;
  }

  get chipTextDesktop() {
    if (this.isDefault) return "Locations";

    const { areas } = this.props;
    const additionalAreasCount = areas.length - 3;
    const additionalAreasSuffix =
      additionalAreasCount > 0 ? ` +${additionalAreasCount}` : "";

    return `${areas
      .slice(0, 3)
      .map((n) => n.name)
      .join(", ")}${additionalAreasSuffix}`;
  }

  get chipTextMobile() {
    if (this.isDefault) return "Locations";

    const { areas } = this.props;
    const additionalAreasCount = areas.length - 1;
    const additionalAreasSuffix =
      additionalAreasCount > 0 ? ` +${additionalAreasCount}` : "";

    return `${areas[0].name}${additionalAreasSuffix}`;
  }

  render() {
    const { onClick, active } = this.props;
    return (
      <>
        <BaseChip
          data-qa="neighborhoods-filter-button"
          className={cn(styles.chip, !this.isDefault && styles.chipDesktop)}
          onClick={onClick}
          active={active}
        >
          {this.chipTextDesktop}
        </BaseChip>
        <BaseChip
          data-qa="neighborhoods-filter-button"
          style={{ display: "none" }}
          className={cn(styles.chip, !this.isDefault && styles.chipMobile)}
          onClick={onClick}
          active={active}
        >
          {this.chipTextMobile}
        </BaseChip>
      </>
    );
  }
}

Chip.propTypes = {
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  areas: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ).isRequired,
};
